import PolicyLayout from "layout/Policy";
import { styled } from "@mui/material/styles";
import TDpolicy from "assets/image/TD-policy-Background-03.png";
import { Divider } from "@mui/material";
import { useTranslation } from "react-i18next";

const Title = styled(`div`)`
  font-size: 3.875rem;
  line-height: 120%;
  /* or 74px */
  letter-spacing: -0.5px;
  /* Text/Primary */
  color: rgba(0, 0, 0, 0.87);
  padding-top: 224px;
  margin-bottom: 95px;
  white-space: pre-line;
  ${({ theme }) => theme.breakpoints.down("lg")} {
    padding-left: 24px;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    padding-top: 80px;
    padding-left: 9px;
    font-size: 2rem;
    margin-bottom: 40px;
  }
`;
const Subtitle = styled(`div`)`
  font-size: 1.125rem;
  line-height: 150%;
  /* or 27px */
  letter-spacing: 0.15px;

  /* Text/Secondary */
  color: #707070;
  white-space: pre-line;

  ${({ theme }) => theme.breakpoints.down("lg")} {
    padding-left: 24px;
  }
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 1rem;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    padding-left: 9px;
    font-size: 0.875rem;
  }
`;
const ContainerPolicy = styled(`div`)`
  padding: 95px;
  ${({ theme }) => theme.breakpoints.down("lg")} {
    padding: 24px;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    padding: 9px;
    margin-bottom: 40px;
  }
`;
const WrapperContact = styled(`div`)`
  padding-left: 90px;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    padding-left: 20px;
  }
`;
const PolicyHeader = styled(`div`)`
  font-weight: 600;
  font-size: 1.375rem;
  line-height: 160%;
  /* or 35px */
  letter-spacing: 0.15px;

  /* Primary/Main */
  color: #1f7b44;
  white-space: pre-line;
  ${({ theme }) => theme.breakpoints.down("lg")} {
    margin-top: 56px;
  }
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 1rem;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 0.875rem;
  }
`;
const SpaceHeader = styled(`div`)`
  padding-top: 61px;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    padding-top: 21px;
  }
`;
const HeaderNumber = styled(`div`)`
  font-size: 3.875rem;
  line-height: 120%;
  /* or 74px */
  letter-spacing: -0.5px;

  /* Text/Primary */
  color: rgba(0, 0, 0, 0.87);

  min-width: 80px;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 1.375rem;
    min-width: 35px;
  }
`;
const WrapperContent = styled(`div`)`
  display: flex;
  flex-direction: row;
  margin-top: 21px;
`;
const Header = styled(`div`)`
  font-weight: 600;
  font-size: 2.25rem;
  line-height: 123.5%;
  /* or 44px */
  letter-spacing: 0.25px;

  /* Text/Primary */
  color: rgba(0, 0, 0, 0.87);
  white-space: pre-line;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 1.375rem;
  }
`;
const SubNumber = styled(`div`)`
  font-weight: 600;
  font-size: 2.25rem;
  line-height: 123.5%;
  /* or 44px */
  letter-spacing: 0.25px;

  /* Text/Primary */
  color: rgba(0, 0, 0, 0.87);
  min-width: 80px;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 1.375rem;
    min-width: 35px;
  }
`;
const SubDescription = styled(`div`)`
  font-weight: 500;
  font-size: 1.125rem;
  line-height: 150%;
  /* or 27px */
  letter-spacing: 0.15px;

  /* Text/Primary */
  color: #707070;
  white-space: pre-line;
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 1rem;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 0.875rem;
  }
`;
const SubDiveNumber = styled(`div`)`
  font-weight: 600;
  font-size: 1.625rem;
  line-height: 133.4%;
  /* identical to box height, or 35px */
  /* Text/Primary */
  color: rgba(0, 0, 0, 0.87);
  min-width: 80px;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 1.375rem;
    min-width: 60px;
  }
`;
const SubNumberItem = styled(`div`)`
  font-weight: 600;
  font-size: 1.375rem;
  line-height: 160%;
  /* or 35px */
  letter-spacing: 0.15px;

  /* Text/Secondary */
  color: #707070;
  margin-right: 22px;
  white-space: pre-line;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 1.375rem;
  }
`;
const Strong = styled(`span`)`
  font-weight: 700;
  font-size: 1.125rem;
  color: rgba(0, 0, 0, 0.9);
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 1rem;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 0.875rem;
  }
`;

const BgMask = styled(`div`)`
  background: linear-gradient(
    11deg,
    #fafafa 60%,
    rgba(230, 230, 230, 0.630208) 119.16%,
    rgba(196, 196, 196, 0) 160.19%
  );
  width: 100vw;
  height: 886px;
`;
const Bg = styled(`div`)`
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: -1;
  &:before {
    content: "";
    position: absolute;
    z-index: -1;
    background: url(${TDpolicy});
    top: 0px;
    width: 100vw;
    height: 885px;
    background-size: contain;
    background-repeat: repeat;
  }
`;

export default function PolicyPage() {
  const { t } = useTranslation(["policy"]);
  return (
    <PolicyLayout>
      <Title>{t("policy_title")}</Title>

      <Bg>
        <BgMask />
      </Bg>
      <Subtitle>{t("policy_desc")}</Subtitle>
      <ContainerPolicy>
        <PolicyHeader>{t("definitions")}</PolicyHeader>

        {t("policy_detail", { returnObjects: true }).map((item, index) => (
          <SpaceHeader key={"title" + index} id={item.id}>
            <Divider />
            <WrapperContent>
              <HeaderNumber>{index + 1}.</HeaderNumber>
              <div>
                <Header>{item.title}</Header>

                {item?.describe?.map((itemdescription, subindex) => (
                  <div key={"subtitle" + subindex}>
                    <WrapperContent>
                      <SubNumber>
                        {index + 1}.{subindex + 1}.
                      </SubNumber>
                      <SubDescription>
                        <div>
                          <Strong>{itemdescription?.strong}</Strong>
                          {itemdescription.detial}
                        </div>
                        <div>
                          {itemdescription?.subdetail?.map(
                            (itemsubdetail, subdetailindex) => (
                              <WrapperContent
                                key={"description" + subdetailindex}
                              >
                                <SubDiveNumber>
                                  {index + 1}.{subindex + 1}.
                                  {subdetailindex + 1}.
                                </SubDiveNumber>
                                <SubDescription>
                                  <div>{itemsubdetail.describe}</div>
                                  {itemsubdetail?.item?.map(
                                    (itemsubdes, indexsubdes) => (
                                      <WrapperContent
                                        key={"subdesription" + indexsubdes}
                                      >
                                        <SubNumberItem>
                                          {index + 1}.{subindex + 1}.
                                          {subdetailindex + 1}.{indexsubdes + 1}
                                          .
                                        </SubNumberItem>
                                        <SubDescription>
                                          {itemsubdes}
                                        </SubDescription>
                                      </WrapperContent>
                                    )
                                  )}
                                </SubDescription>
                              </WrapperContent>
                            )
                          )}
                        </div>
                      </SubDescription>
                    </WrapperContent>
                  </div>
                ))}
                <SubDescription style={{ margin: 20 }}>
                  {item?.id === "contact" ? (
                    <div>
                      <div>{item?.other?.desc}</div>
                      <div style={{ marginTop: 20 }}>
                        <Strong> {item?.other?.position1}</Strong>
                        <WrapperContact>
                          <div style={{ marginTop: 20 }}>
                            <Strong> {item?.other?.name1}</Strong>
                          </div>
                          <div>{item?.other?.position2}</div>
                          <div style={{ marginTop: 20 }}>
                            {item?.other?.address}
                          </div>
                          <div style={{ marginTop: 20 }}>
                            {item?.other?.email}
                          </div>
                        </WrapperContact>
                      </div>
                      <div style={{ marginTop: 20 }}>
                        <Strong>{item?.other?.contact_title}</Strong>
                        <WrapperContact>
                          <div style={{ marginTop: 20, wordSpacing: "pre" }}>
                            {item?.other?.address_contact}
                          </div>
                        </WrapperContact>
                      </div>
                    </div>
                  ) : (
                    item?.other
                  )}
                </SubDescription>
              </div>
            </WrapperContent>
          </SpaceHeader>
        ))}
        <div>
          <SubDescription
            style={{ color: "#1F7B44", marginBottom: 30, marginTop: 20 }}
          >
            นโยบายฯ นี้ได้มีการปรับปรุงแก้ไขครั้งล่าสุดเมื่อ 06/09/2564
          </SubDescription>
          <SubDescription>
            หากท่านมีข้อสงสัย หรือข้อกังวลเกี่ยวกับนโยบายฯ นี้
            หรือเกี่ยวกับการจัดการข้อมูลส่วนบุคคลของท่านโดยบริษัท
            <br />
            กรุณาติดต่อเราที่ช่องทางการติดต่อที่แจ้งไว้ในนโยบายฯ ข้อที่ 12
          </SubDescription>
        </div>
      </ContainerPolicy>
    </PolicyLayout>
  );
}
